import React from "react";

// Ставка к курсу биржи: валидация и подсказка под полем.

// Зеркало серверной валидации (internal/merchant/handler.go rateMarkupPattern):
// знак необязателен, не более 2 знаков после точки, N > −100 (иначе множитель
// (1 + N/100) даёт нулевой или отрицательный курс). Бизнес-рамок на ставку нет:
// направление спреда — решение админа. Потолок 999.99 — тоже не бизнес-рамка, а
// ёмкость колонки merchants.rate_markup_percent NUMERIC(5,2).
const RATE_MARKUP_PATTERN = /^[+-]?\d+(?:\.\d{1,2})?$/;
const RATE_MARKUP_MAX = 999.99;

export function validateRateMarkup(raw: string): string | null {
    if (raw === "") return "обязательна для источника «Rapira»";
    if (!RATE_MARKUP_PATTERN.test(raw)) return "число со знаком, не более 2 знаков после точки";
    if (Number(raw) <= -100) return "должна быть больше −100";
    if (Number(raw) > RATE_MARKUP_MAX) return "не больше 999.99";
    return null;
}

// База для подсказки в форме. Локальный пример, а не живой курс: ходить в API
// биржи ради подсказки не нужно, а показать эффект знака ставки — нужно.
const RATE_HINT_BASE = 80;

/** Пример эффекта ставки на курс заявки для подсказки под полем.
 *  Только для показа: настоящий курс считает бэк на decimal. */
export function rateHintExample(raw: string): string | null {
    if (validateRateMarkup(raw) !== null) return null;
    const percent = Number(raw);
    const fixed = RATE_HINT_BASE * (1 + percent / 100);
    if (!Number.isFinite(fixed) || fixed <= 0) return null;
    const sign = percent < 0 ? "−" : "+";
    return `Рапира ${RATE_HINT_BASE.toFixed(2)}, ставка ${sign}${Math.abs(percent)}% → курс заявки ${fixed.toFixed(2)}`;
}

/** Что ставка делает с расчётом — словами, под примером курса.
 *  Расчёт идёт от курса: USDT = RUB / курс, поэтому курс выше → USDT меньше. */
export function rateMarkupEffect(percent: number): React.ReactNode {
    if (percent < 0) {
        return (
            <>
                Курс ниже — мерчант спишется <strong>бо́льшим</strong> количеством USDT за ту же
                выплату (команда получит больше).
            </>
        );
    }
    if (percent === 0) {
        return <>Ставка 0 — курс заявки равен курсу биржи, расчёт не меняется.</>;
    }
    return (
        <>
            Курс выше — мерчант спишется <strong>меньшим</strong> количеством USDT за ту же выплату
            (команда получит меньше).
        </>
    );
}
